<label class="fw-bold form-label">{{localize(langSection.LocationList, langText.SearchLocations)}}</label>
<div class="input-group-text">
    <input class="form-control rounded-0 border-dark" [(ngModel)]="locationSearchString"
      (input)="searchForLocation()" />
    <button aria-label="Search Locations" class="btn border-dark rounded-0 bg-green" type="button"
      (click)="clearLocationSearch()"><span class="{{iconClass}}"></span></button>
  </div>
